export enum LangType {
    en = <any>'general.enum.lang.type.en',
    tr = <any>'general.enum.lang.type.tr'
}
